<div *ngIf="(dimensions$ | async).length>0" style="padding-top: 0px" class="pro-tag">
  <!-- <hr/> -->
  <ng-container *ngFor="let dimension of dimensions$ | async; let index = index;">
    <strong>
      {{dimension.name}}
    </strong>
    <div class="box">
      <ng-container *ngFor="let item of dimension.data;">

        <div (click)="getDetails(item.product)"  [class.active]="(currentKey$ | async)==item.key" [class.disable]="!item.product && provider==1" class="item" *ngIf="!item.displayMedia; else displayMedia">
          <span style="max-width: 70px;">
            {{item.displayValue}}
          </span>
        </div>
        <ng-template #displayMedia>
          <div (click)="getDetails(item.product)" [class.active]="(currentKey$ | async)==item.key" [class.disable]="!item.product && provider==1" class="item disable">
            <span style="max-width: 70px;">
              <img style="max-width: 70px;" src="{{item.displayMedia}}" />
            </span>
          </div>
        </ng-template>


       <!--  <div (click)="getDetails(item.product)"  [class.active]="(currentKey$ | async)==item.key" [class.disable]="!item.product" class="item" *ngIf="!item.displayMedia; else displayMedia">
          <span style="max-width: 70px;">
            {{item.displayValue}}
          </span>
        </div>
        <ng-template #displayMedia>
          <div (click)="getDetails(item.product)" [class.active]="(currentKey$ | async)==item.key" [class.disable]="!item.product" class="item disable">
            <span style="max-width: 70px;">
              <img style="max-width: 70px;" src="{{item.displayMedia}}" />
            </span>
          </div>
        </ng-template> -->

      </ng-container>
    </div>
  </ng-container>
</div>


